import React from 'react';
import { AuthConsumer } from './AuthProvider';
import styled from 'styled-components';
import { LoadingScreen } from '@ibinder/common-frontend';

export const LoginLoader = styled.div`
  position: fixed;
  height: 100vh;
  width: 100vw;
  background: white;
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    font-size: 3rem;
  }
`;

export const Callback = ({
  loginText,
  waitText
}: {
  loginText: string;
  waitText: string;
}) => (
  <AuthConsumer>
    {({ signinRedirectCallback }) => {
      signinRedirectCallback();

      return (
        <LoadingScreen
          statusMessage={loginText}
          loadingText={waitText}
          fullscreen={true}
        />
      );
    }}
  </AuthConsumer>
);
